export default __webpack_public_path__ + "static/media/contact-bg.f255295e.jpg";